import { combineReducers } from 'redux';
import pushAlarmlist from './pushAlarmlist';
import fetching from './fetching';

export default combineReducers({
  fetching,
  pushAlarmlist,
});
